/* zepto-fast-atc.js
   1) Instant add-to-cart on personalized products (bypasses Zepto's slow canvas engine
      by submitting the theme's own product form directly).
   2) Case-normalizes the typed initials (Zepto normally upper/lower-cases the value during
      ITS submit flow, which we bypass; the visible field is only styled via CSS).
   3) Cart-drawer initials SAFETY-NET: surfaces the initials value for ANY field-name variant
      ("Add Initials (Optional)", a stray leading space, "Add Initial", ...).
   4) Preview WARM-UP: on page idle, prefetch Zepto's per-product mockup image(s) + the font
      (read from window.pplr_product / product_personalizer), so the first keystroke's preview
      renders without waiting on the network image download. No UI interaction, no focus.
   5) Pre-order label MIRROR: mirrors the main button's pre-order state onto the secondary
      "Buy" buttons (down-product bar + quick-view popup) on the product page. */
(function () {
  if (window.__zeptoFastAtc) return;
  window.__zeptoFastAtc = true;

  var CANON_LABEL = 'Add Initials (Optional)';

  function isPersonalized() {
    return !!document.querySelector('.pplr_atc_form, .pplr_text, input.pplr_monogram');
  }

  function applyCaseTransform(input) {
    var v = input.value;
    if (!v) return;
    var cl = input.classList;
    if (cl.contains('toUpperCase')) input.value = v.toUpperCase();
    else if (cl.contains('toLowerCase')) input.value = v.toLowerCase();
    else if (cl.contains('capitalize')) input.value = v.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  /* ---------- initials length guard (Claude, Aug 2026) ----------
     Order #66129 shipped with a full first name in a field that allows 2 characters.
     Cause: maxlength only constrains TYPING and PASTING - it does NOT apply to a value
     written programmatically or by BROWSER AUTOFILL, and Zepto's field carries no
     autocomplete attribute, so a browser could drop a saved name straight into it.
     There was no submit-time or server-side check anywhere, and this script deliberately
     bypasses Zepto's own submit handler for speed, so nothing trimmed it.
     Guard, in three layers: (a) tell browsers not to autofill the field, (b) trim to the
     field's OWN maxlength the moment it changes, (c) trim again at submit - the real
     backstop, since it runs no matter how the value got there. */
  function initialsLimitOf(input) {
    var lim = parseInt(input.getAttribute('maxlength') || input.getAttribute('data-maxlength'), 10);
    return (!lim || isNaN(lim) || lim < 1) ? 0 : lim;
  }

  function enforceInitialsLimit(input) {
    var lim = initialsLimitOf(input);
    if (!lim) return;
    var v = input.value || '';
    if (v.length > lim) input.value = v.slice(0, lim);
  }

  function hardenInitialsInputs(attempt) {
    attempt = attempt || 0;
    document.querySelectorAll('input.pplr_text, input.pplr_monogram').forEach(function (i) {
      if (i.getAttribute('autocomplete') !== 'off') i.setAttribute('autocomplete', 'off');
      enforceInitialsLimit(i);
    });
    /* Zepto builds its field late and then RELOCATES it, so re-assert for a while. */
    if (attempt < 20) setTimeout(function () { hardenInitialsInputs(attempt + 1); }, 500);
  }

  /* Covers the Zepto field on the product page AND the cart-drawer editor. These run in
     the CAPTURE phase, and initials-editor.js saves on a BUBBLE-phase change listener, so
     the value is already trimmed by the time the save reads it. */
  function isInitialsField(t) {
    return !!(t && t.classList && (t.classList.contains('pplr_text') ||
      t.classList.contains('pplr_monogram') || t.classList.contains('cart-item__initials-input')));
  }
  document.addEventListener('input', function (e) { if (isInitialsField(e.target)) enforceInitialsLimit(e.target); }, true);
  document.addEventListener('change', function (e) { if (isInitialsField(e.target)) enforceInitialsLimit(e.target); }, true);

  function normalizeInitials(pf) {
    var form = pf.form || pf.querySelector('form');
    (form || document).querySelectorAll('.pplr_text, .pplr_monogram').forEach(function (i) {
      enforceInitialsLimit(i);   // backstop: catches autofilled / programmatic values too
      applyCaseTransform(i);
    });
  }

  /* ---------- cart-drawer initials safety-net ---------- */

  function initialsFromProps(props) {
    if (!props) return '';
    var val = '';
    Object.keys(props).forEach(function (k) {
      if (String(k).charAt(0) === '_') return;
      if (String(k).trim().toLowerCase().indexOf('initial') === -1) return;
      var v = props[k];
      if (v && String(v).indexOf('/uploads/') === -1) val = v;
    });
    return val;
  }

  function ensureInitialsShown() {
    if (!document.getElementById('CartDrawer-CartItems')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item, i) {
          var val = initialsFromProps(item.properties);
          if (!val) return;
          var row = document.getElementById('CartDrawer-Item-' + (i + 1));
          if (!row) return;
          if (!row.querySelector('.cart-item__initials-display')) {
            var disp = document.createElement('div');
            disp.className = 'cart-item__initials-display product-option d-flex align-items-center font-15 leading-16 spacing-0 text-0F0F0F font-light';
            var lab = document.createElement('span');
            lab.className = 'd-flex font-semibold';
            lab.innerHTML = CANON_LABEL + ':&nbsp;';
            var v = document.createElement('span');
            v.textContent = val;
            disp.appendChild(lab);
            disp.appendChild(v);
            var editWrap = row.querySelector('.cart-item__initials-edit');
            if (editWrap && editWrap.parentNode) editWrap.parentNode.insertBefore(disp, editWrap);
            else (row.querySelector('.col-9') || row).appendChild(disp);
          }
          var input = row.querySelector('.cart-item__initials-input');
          if (input && !input.value) { input.value = val; input.setAttribute('data-original', val); }
          var editor = row.querySelector('.cart-item__initials-edit');
          if (editor && !editor.classList.contains('is-collapsed')) editor.classList.add('is-collapsed');
          var editBtn = row.querySelector('.cart-item__edit-btn--toggles-initials');
          if (editBtn) editBtn.setAttribute('aria-expanded', 'false');
        });
      })
      .catch(function () {});
  }

  var scheduled = false;
  function scheduleNormalize() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; ensureInitialsShown(); }, 60);
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (drawer && !drawer.__initialsWatched) {
      drawer.__initialsWatched = true;
      new MutationObserver(scheduleNormalize).observe(drawer, { childList: true, subtree: true });
    }
    scheduleNormalize();
  }

  /* ---------- preview warm-up (prefetch mockup image(s) + font on idle) ---------- */

  function collectAssetUrls() {
    var imgs = {}, fonts = {};
    function scan(o, d) {
      if (d > 6 || o == null) return;
      if (typeof o === 'string') {
        if (o.indexOf(',') === -1 && /\.(png|jpe?g|webp)(\?|$)/i.test(o) && /(^\/\/|\/cdn\/|https?:)/.test(o)) imgs[o] = 1;
        var fm = o.match(/font\/[^,\x22'\s]+\.(?:ttf|otf|woff2?)/ig);
        if (fm) fm.forEach(function (f) { fonts['https://cdn-zeptoapps.com/product-personalizer/' + f] = 1; });
        return;
      }
      if (typeof o !== 'object') return;
      for (var k in o) { try { scan(o[k], d + 1); } catch (e) {} }
    }
    try { scan(window.pplr_product, 0); } catch (e) {}
    try { scan(window.product_personalizer, 0); } catch (e) {}
    return { images: Object.keys(imgs), fonts: Object.keys(fonts) };
  }

  function warmPreview(attempt) {
    attempt = attempt || 0;
    var a = collectAssetUrls();
    if (!a.images.length && !a.fonts.length) {
      if (attempt < 15) setTimeout(function () { warmPreview(attempt + 1); }, 500);
      return;
    }
    a.images.forEach(function (u) {
      var s = u.indexOf('//') === 0 ? ('https:' + u) : u;
      var im = new Image();
      im.decoding = 'async';
      im.src = s;
    });
    a.fonts.forEach(function (u, i) {
      if (document.querySelector('link[data-pplr-font="' + i + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.as = 'font';
      l.crossOrigin = 'anonymous';
      l.href = u;
      l.setAttribute('data-pplr-font', String(i));
      document.head.appendChild(l);
    });
  }

  function schedulePreviewWarm() {
    var run = function () { warmPreview(0); };
    /* Never inside a PRERENDERED page - warm work there slows the prerender itself. */
    if (document.prerendering) { document.addEventListener('prerenderingchange', function () { schedulePreviewWarm(); }, { once: true }); return; }
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 3000 });
    else setTimeout(run, 1200);
  }

  /* ---------- pre-order label mirror (down-product bar + quick-view popup) ----------
     These secondary "Buy" buttons live in large section files (down-product / the ~108KB
     main-product). Rather than edit those, we mirror the main product-form button's
     pre-order state onto them on the product page. Buttons are below the fold / in a popup,
     so the relabel happens before they're seen. Reverts to "Buy" if a variant is in stock. */

  function syncSecondaryBuyButtons() {
    var mainBtn = document.querySelector('product-form button[name="add"]');
    if (!mainBtn) return;
    var isPre = mainBtn.getAttribute('data-preorder') === 'true' || mainBtn.classList.contains('is-preorder');
    var label = isPre ? 'Pre-Order' : 'Buy';
    ['.down-product-buy-btn', '.product-popup__buy-button'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (a) {
        var t = (a.textContent || '').trim();
        if (t === 'Buy' || t === 'Pre-Order') a.textContent = label;
      });
    });
  }

  function watchPreorderButtons() {
    syncSecondaryBuyButtons();
    var mainBtn = document.querySelector('product-form button[name="add"]');
    if (mainBtn && !mainBtn.__preorderMirror) {
      mainBtn.__preorderMirror = true;
      new MutationObserver(syncSecondaryBuyButtons).observe(mainBtn, { attributes: true, attributeFilter: ['data-preorder', 'class'] });
    }
    setTimeout(syncSecondaryBuyButtons, 800);
    setTimeout(syncSecondaryBuyButtons, 2000);
  }

  /* ---------- instant add-to-cart ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('button[name="add"], [type="submit"][name="add"]') : null;
    if (!btn || !isPersonalized()) return;
    var pf = btn.closest('product-form') || document.querySelector('product-form');
    if (!pf || typeof pf.onSubmitHandler !== 'function') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try {
      normalizeInitials(pf);
      pf.onSubmitHandler(e);
    } catch (err) {
      console.error('[zepto-fast-atc]', err);
    }
  }, true);

  /* ---------- colour-swatch navigation: keep the shopper's place ----------
     Each colour is a SEPARATE Shopify product (own handle), so changing colour is a full
     page navigation and the browser lands back at the top. Two improvements:
     1) remember the scroll position when a swatch is clicked and restore it on the next
        product page (re-applied after load + a settle delay because image heights shift);
     2) prefetch a sibling colour page the first time its swatch is hovered/touched so
        the navigation itself is faster. Zepto, the product form and every app still get
        a full, normal page load - nothing is swapped client-side, so per-product
        personalisation config cannot break. */
  var SWATCH_WRAP = '.product-form__input--swatch';

  /* ---------- tap feedback for colour swatches (mobile) ----------
     On phones the tap-to-first-frame gap can run seconds on slow networks, and the
     cross-document view transition HOLDS the old frame during that wait - so there was
     no visible cue the tap registered and shoppers tapped again. Give instant feedback:
     the tapped swatch takes the active ring + a press pulse the moment the finger lands,
     and a thin brand-colour progress bar runs along the top of the old page until the
     new page takes over (the bar rides into the cross-fade and vanishes with it). Works
     identically in browsers without view-transition support. */
  function swatchFeedbackCss() {
    if (document.getElementById('sc-swatch-feedback-css')) return;
    var st = document.createElement('style');
    st.id = 'sc-swatch-feedback-css';
    st.textContent = '#sc-nav-progress{position:fixed;top:0;left:0;height:3px;width:0;background:#003153;z-index:99999;animation:scNavFill 2.5s cubic-bezier(.2,.7,.3,1) forwards}' +
      '@keyframes scNavFill{0%{width:0}60%{width:70%}100%{width:92%}}' +
      '@media (prefers-reduced-motion: no-preference){.sc-swatch-pressed{transform:scale(.9);transition:transform .12s ease}}';
    document.head.appendChild(st);
  }
  function startNavProgress() {
    swatchFeedbackCss();
    if (document.getElementById('sc-nav-progress')) return;
    var bar = document.createElement('div');
    bar.id = 'sc-nav-progress';
    document.body.appendChild(bar);
    // If the navigation never happens (offline etc.) the bar should not linger forever.
    setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 12000);
  }

  function keepSwatchScroll() {
    document.addEventListener('touchstart', function (e) {
      var a4 = e.target && e.target.closest ? e.target.closest(SWATCH_WRAP + ' a[href*="/products/"]') : null;
      if (!a4) return;
      swatchFeedbackCss();
      a4.classList.add('sc-swatch-pressed');
    }, { capture: true, passive: true });

    document.addEventListener('click', function (e) {
      var a2 = e.target && e.target.closest ? e.target.closest(SWATCH_WRAP + ' a[href*="/products/"]') : null;
      if (!a2) return;
      /* localStorage, not sessionStorage: prerendered pages get a CLONE of session
         storage taken when the prerender starts, so a marker written at tap time would
         be invisible to them. localStorage is shared live; the 8s TTL keeps it safe. */
      var phList = [];
      try {
        var fbBlocks = document.querySelectorAll('div[id^="shopify-block-"][id*="fast_bundle"]');
        for (var fb = 0; fb < fbBlocks.length; fb++) {
          var fbId = fbBlocks[fb].id;
          var fbCut = fbId.indexOf('__');
          /* Send only the id SUFFIX (block handle + block id): the shopify-block random
             prefix is different on every product, the suffix is stable across siblings. */
          if (fbCut > -1 && fbBlocks[fb].offsetHeight > 40) phList.push({ s: fbId.slice(fbCut + 2), h: fbBlocks[fb].offsetHeight });
        }
      } catch (err) {}
      try {
        var zMount = document.querySelector('.product__info-wrapper div[id^="pplr"]');
        if (zMount && zMount.offsetHeight > 20) phList.push({ z: 1, h: zMount.offsetHeight });
      } catch (err) {}
      try { localStorage.setItem('sc_swatch_scroll', JSON.stringify({ y: window.scrollY || 0, ts: Date.now(), ph: phList })); } catch (err) {}
      /* Instant acknowledgement: hand the active ring to the tapped colour right now -
         the incoming page renders the same swatch active, so the feedback is continuous
         through the cross-fade. */
      try {
        var wrapEl = a2.closest(SWATCH_WRAP);
        if (wrapEl) wrapEl.querySelectorAll('a.active').forEach(function (x) { x.classList.remove('active'); });
        a2.classList.add('active');
        a2.classList.add('sc-swatch-pressed');
      } catch (err) {}
      startNavProgress();
    }, true);

    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('sc_swatch_scroll') || 'null'); } catch (err) { saved = null; }
    if (saved && (Date.now() - saved.ts) < 8000 && saved.y > 0) {
      try { localStorage.removeItem('sc_swatch_scroll'); } catch (err) {}
      var apply = function () { window.scrollTo(0, saved.y); };
      apply();
      window.addEventListener('load', apply);
      setTimeout(apply, 400);
      setTimeout(apply, 1200);
    }

    // Prefetch sibling colour pages on first hover/touch of their swatch.
    var prefetched = {};
    function prefetchSwatch(e) {
      var a3 = e.target && e.target.closest ? e.target.closest(SWATCH_WRAP + ' a[href*="/products/"]') : null;
      if (!a3) return;
      var href = a3.getAttribute('href');
      if (!href || prefetched[href]) return;
      prefetched[href] = true;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      document.head.appendChild(l);
    }
    document.addEventListener('pointerenter', prefetchSwatch, true);
    document.addEventListener('touchstart', prefetchSwatch, true);

    /* Warm the sibling colours' hero images during idle: on phones there is no hover to
       drive the prefetch above, and the hero is the heaviest first-paint asset on the
       incoming page. Fetch each sibling page once (also warms the CDN edge), read its
       og:image and pull that into the HTTP cache so arrival paints the hero instantly. */
    function warmSiblingHeroes() {
      var seenW = {};
      var linksW = document.querySelectorAll(SWATCH_WRAP + ' a[href*="/products/"]');
      var jobsW = [];
      for (var wi = 0; wi < linksW.length; wi++) {
        var wh = linksW[wi].getAttribute('href');
        if (!wh || seenW[wh] || wh === location.pathname) continue;
        seenW[wh] = 1;
        jobsW.push(wh);
      }
      jobsW.slice(0, 3).forEach(function (u) {
        fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (tx) {
          var hm = tx.match(/property=[\x22\x27]og:image[\x22\x27]\s+content=[\x22\x27]([^\x22\x27]+)/);
          if (hm && hm[1]) { var him = new Image(); him.decoding = 'async'; him.src = hm[1]; }
        }).catch(function (err) {});
      });
    }
    /* Inside a PRERENDERED page these fetches are pure overhead: every landing spawns
       up to 3 background pages, and each would fetch ITS OWN 3 siblings (9 page fetches
       + images) - competing with the very prerenders they ride in. Defer to activation. */
    function scheduleSiblingWarm() {
      if ('requestIdleCallback' in window) requestIdleCallback(function () { warmSiblingHeroes(); }, { timeout: 4000 });
      else setTimeout(warmSiblingHeroes, 2000);
    }
    if (document.prerendering) document.addEventListener('prerenderingchange', scheduleSiblingWarm, { once: true });
    else scheduleSiblingWarm();
  }

  /* ---------- delivery-check label (Claude) ----------
     The pincode block is rendered by the Axentra app and its label text is hardcoded in
     the app's own markup (its theme block exposes no settings), so it is renamed here.
     "Delivery Details" is the standard CHECKOUT heading for the address form and names a
     category rather than prompting anything; the block returns a DATE, so name it.
     Title Case matches the sibling labels ("Color", "Add Initials (Optional)").
     Re-asserted for 10s in case the app re-renders its block after first paint. */
  var DELIVERY_LABEL = 'Estimated Delivery Date';
  function renameDeliveryLabel() {
    var l = document.querySelector('.ax-pincode-label');
    if (l && l.textContent.trim() !== DELIVERY_LABEL) l.textContent = DELIVERY_LABEL;
  }
  function watchDeliveryLabel(attempt) {
    attempt = attempt || 0;
    renameDeliveryLabel();
    if (attempt < 20) setTimeout(function () { watchDeliveryLabel(attempt + 1); }, 500);
  }

  function boot() { watchDrawer(); schedulePreviewWarm(); watchPreorderButtons(); keepSwatchScroll(); watchDeliveryLabel(0); hardenInitialsInputs(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();